import OrderComponent from "../../components/orders/OrderComponent";
// import OrdersDashboard from "../../components/orders-dashboard/OrdersDashboard";
import {
  // StyledGridBorder,
  StyledGridContainer,
  // StyledGridContainerPack,
  StyledWelcomeBanner,
  StyledWrapper,
} from "./style";
import Grid from "@mui/material/Grid2";
import WelcomeBanner from "../../components/welcome-banner/WelcomeBanner";
// import ShipmentTracking from "../../components/shipment-tracking/ShipmentTracking";
// import StepperDelivery from "../../components/delivery-status/StepperDelivery";
import InvitationList from "../../components/list-invitations/ListInvitations";

/*
 * Original ORDERS statistics cards — commented out (not removed).
 * Uncomment imports below + component logic + JSX to restore blue summary cards.
 *
 * import OrdersDashboard from "../../components/orders-dashboard/OrdersDashboard";
 * import { orderData, statisticsTitles } from "./constant";
 * import { CUSTOMER_ORDER_LIST } from "../../actions/OrderAction";
 * import { useState } from "react";
 * import Loader from "../../components/common/loader/Loader";
 *
 * const [statisticsData, setStatisticsData] = useState(orderData);
 * const { orderSummary, isLoading: isOrderLoading } = useSelector((state) => state?.order);
 *
 * useEffect(() => {
 *   dispatch({ type: CUSTOMER_ORDER_LIST, payload: { page: 1, limit: 10 } });
 * }, [dispatch]);
 *
 * useEffect(() => {
 *   const updated = orderData.map((item) => {
 *     switch (item.title) {
 *       case statisticsTitles.totalRequestsMade:
 *         return { ...item, value: orderSummary?.total_request_made || 0 };
 *       case statisticsTitles.ordersCompleted:
 *         return { ...item, value: orderSummary?.order_completed || 0 };
 *       case statisticsTitles.ordersInProgress:
 *         return { ...item, value: orderSummary?.order_in_progress || 0 };
 *       case statisticsTitles.awaitingPaymentApproval:
 *         return { ...item, value: orderSummary?.await_payment_approval || 0 };
 *       case statisticsTitles.pendingConfirmationFromShopper:
 *         return { ...item, value: orderSummary?.pending_confirmation_from_shopper || 0 };
 *       case statisticsTitles.nextEstimatedDelivery:
 *         return { ...item, value: orderSummary?.next_estimated_delivery || 0 };
 *       default:
 *         return item;
 *     }
 *   });
 *   setStatisticsData(updated);
 * }, [orderSummary]);
 *
 * if (isOrderLoading) return <Loader />;
 */

// import { colorMap, deliverySteps, packingData, shipments } from "./constant";
// import CustomAssign from "../../components/assign/CustomAssign";
import LockerInfo from "../../components/locker-info/VirtualLocker";
import { useDispatch, useSelector } from "react-redux";
import { FETCH_INVITATIONS } from "../../actions/InvitationsActions";
import { useEffect } from "react";

const Dashboard = () => {
  const dispatch = useDispatch();
  const { invitations, isLoading } = useSelector((state) => state.invitations || {});
  const profileDetails = useSelector((state) => state.auth?.profileDetails);

  const invitationList = invitations?.data?.filter(
    (ele) => ele?.invite_emailId === profileDetails?.email && ele?.invitation_status === "pending" ) || [];

  useEffect(() => {
    dispatch({ type: FETCH_INVITATIONS });
  }, [dispatch]);

  return (
    <StyledWrapper>
      <WelcomeBanner />
      {!isLoading && invitationList?.length > 0 &&
        <StyledGridContainer>
          <InvitationList invitationList={invitationList} />
        </StyledGridContainer>
      }
      <Grid container spacing={2} sx={{ alignItems: "stretch" }}>
        <Grid size={{ lg: 7.5, md: 12, xs: 12 }}>
          <StyledWelcomeBanner>
            {/*
              Original ORDERS statistics cards (6 blue summary cards) — do not delete.
              Uncomment file-top block + this line to restore; remove embedded table if cards only.

              <OrdersDashboard title="ORDERS" idDataList={statisticsData || []} />
            */}
            <OrderComponent embedded />
          </StyledWelcomeBanner>
        </Grid>
        <Grid size={{ lg: 4.5, md: 12, xs: 12 }}>
          <StyledWelcomeBanner>
            <LockerInfo />
          </StyledWelcomeBanner>
        </Grid>
      </Grid>
      {/* <StyledGridContainer container>
        <StyledGridBorder size={{ lg: 8, md: 12, xs: 12 }}>
          <ShipmentTracking shipment={shipments} />
        </StyledGridBorder>
        <Grid size={{ lg: 4, md: 12, xs: 12 }}>
          <StepperDelivery deliverySteps={deliverySteps} colorMap={colorMap} />
        </Grid>
      </StyledGridContainer> */}
      {/* <StyledGridContainerPack container spacing={2}>
        <Grid size={{ lg: 7.5, md: 12, xs: 12 }}>
          <OrdersDashboard
            istest={"true"}
            title="Packing Summary"
            background={"true"}
            iscardbackground={true}
            idDataList={packingData || []}
          />
        </Grid>
        <Grid size={{ lg: 4.5, md: 12, xs: 12 }}>
          <CustomAssign />
        </Grid>
      </StyledGridContainerPack> */}
    </StyledWrapper>
  );
};

export default Dashboard;
